// THIS IS AN AUTOGENERATED FILE. DO NOT MODIFY.
import { createIcon } from './utils/createIcon';

export const InfoNoCircle = createIcon(
  <path
    clipRule="evenodd"
    d="M12.0003 7.10048C12.5801 7.10048 13.0501 6.63049 13.0501 6.05073C13.0501 5.47097 12.5801 5.00098 12.0003 5.00098C11.4206 5.00098 10.9506 5.47097 10.9506 6.05073C10.9506 6.63049 11.4206 7.10048 12.0003 7.10048ZM8.64746 10.1233C8.64746 9.62621 9.0504 9.22326 9.54746 9.22326H12.0001C12.4971 9.22326 12.9001 9.62621 12.9001 10.1233C12.9001 10.1539 12.8985 10.1842 12.8955 10.2141C12.8986 10.2441 12.9001 10.2746 12.9001 10.3054V17.1983H14.4527C14.9497 17.1983 15.3527 17.6013 15.3527 18.0983C15.3527 18.5954 14.9497 18.9983 14.4527 18.9983H9.54746C9.0504 18.9983 8.64746 18.5954 8.64746 18.0983C8.64746 17.6013 9.0504 17.1983 9.54746 17.1983H11.1001V11.0233H9.54746C9.0504 11.0233 8.64746 10.6203 8.64746 10.1233Z"
    fillRule="evenodd"
  />,
);
